import React from "react";
import "./Invite_Top_Banner.css";

function Invite_Top_Banner() {
  return (
<section className="Invite_Top_Banner_holder">

    <div className="bg_holder">
          <img
            src="/assets/images/Invitation_Bonus/Invite_Top_Banner/bonus_banner_bg.png"
            className="bg_img"
            alt="bg"
          />
        </div>
    <div className="Invite_Top_Banner">
      <h3>Invite friends and deposit 🎉</h3>
      <p>Both parties can receive rewards</p>
      <p>Invite friends to register and recharge to receive rewards</p>
      <p>activity date</p>
      <p className="date">2000-01-01 - 2099-01-01</p>
    </div>
</section>
  );
}

export default Invite_Top_Banner;